import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Process3rd.css";

const Process3rd = ({ processData }) => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // ========================
  // 💡 All data in one object
  // ========================

  // ========================
  // 💡 Render Section
  // ========================
  return (
    <div className="thirdProcessMain row">
      {/* Left Text Section (Header) */}
      <div className="textSection col-md-6 d-flex align-items-center justify-content-center">
        <div className="col-md-8 col-11 m-auto text-start">
          <p className="text-secondary mt-2" data-aos="fade-up">
            {processData.topText}
          </p>
          <p className="fs-1 fw-bold" data-aos="fade-up">
            {processData.titleMain}
          </p>
          <p className="fs-1 fw-bold org line-height-1 mb-2" data-aos="fade-up">
            {processData.titleHighlight}
          </p>
          <p className="fs-5 fw-r" data-aos="fade-up">
            {processData.description}
          </p>
          <button
            className="buttonEffect mb-2"
            data-aos="fade-up"
            onClick={() => navigate(processData.buttonLink)}
          >
            {processData.buttonText}
          </button>
        </div>
      </div>

      {/* Right Product Section */}
      <div className="slideSection col-md-6 col-11 m-auto">
        <div className="slideSectionExtraSpace"></div>

        {processData.products.map((item) => (
          <div className="d-flex gap-3 mb-4" key={item.id}>
            {/* Left Number Section */}
            <div>
              <p className="display-1 fw-bold org bg-white">{item.id}</p>
              <div
                className="m-auto"
                style={{ width: "8px", height: "100%", background: "#F47024" }}
              ></div>
            </div>

            {/* Right Text Section */}
            <div className="d-flex justify-content-center">
              <div className="col-md-10 mx-auto mt-4 text-start">
                <p
                  className="fs-1 fw-bold"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                ></p>
                <p className="fs-4 org fw-semibold">{item.subtitle}</p>

                {item.content.map((para, i) => (
                  <p
                    className="fs-5 tJustify mb-3"
                    key={i}
                    dangerouslySetInnerHTML={{ __html: para }}
                  ></p>
                ))}

                {item.buttonText && (
                  <button
                    className="buttonEffect"
                    onClick={() => navigate(item.buttonLink)}
                  >
                    {item.buttonText}
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Process3rd;
